import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { CheckCircle2 } from "lucide-react";

export const SuccessScreen = ({ isRTL, t, sterileResult, medicalReportResult, onReset }) => (
  <div
    className="min-h-screen bg-[#F8F7FC] flex items-center justify-center p-4"
    dir={isRTL ? "rtl" : "ltr"}
  >
    <Card className="w-full max-w-md border-0 shadow-lg text-center">
      <CardContent className="pt-12 pb-8">
        <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-10 h-10 text-green-600" />
        </div>
        <h2 className="text-2xl font-bold text-[#4a3fa8] mb-3">{t.successTitle}</h2>
        {medicalReportResult ? (
          <>
            <p className="text-slate-500 mb-3">
              {isRTL ? "رقم طلب التقرير الطبي:" : "Your medical report request number:"}
            </p>
            <div className="inline-block bg-sky-50 border-2 border-sky-500 rounded-xl px-6 py-3 mb-4">
              <span className="text-2xl font-mono font-bold text-sky-700 tracking-wider">
                {medicalReportResult.request_number}
              </span>
            </div>
            <p className="text-xs text-slate-500 mb-6">
              {isRTL
                ? "سيتم إشعارك عبر واتساب فور جهوز التقرير."
                : "You will be notified via WhatsApp once the report is ready."}
            </p>
          </>
        ) : sterileResult ? (
          <>
            <p className="text-slate-500 mb-3">
              {isRTL ? "رقم تتبع طلب التعقيم:" : "Your sterilization tracking number:"}
            </p>
            <div className="inline-block bg-[#F5F3F9] border-2 border-[#655dc6] rounded-xl px-6 py-3 mb-4">
              <span className="text-2xl font-mono font-bold text-[#4a3fa8] tracking-wider">
                {sterileResult.tracking_number}
              </span>
            </div>
            <p className="text-xs text-slate-500 mb-6">
              {isRTL
                ? "سيتم تسليم الأدوات من مستودع التعقيم بعد جاهزيتها."
                : "Instruments will be handed over by the Sterile Storage once ready."}
            </p>
          </>
        ) : (
          <p className="text-slate-500 mb-6">{t.successMessage}</p>
        )}
        <Button
          onClick={onReset}
          className="bg-[#655dc6] hover:bg-[#5449a8] text-white"
          data-testid="submit-another-btn"
        >
          {t.submitAnother}
        </Button>
      </CardContent>
    </Card>
  </div>
);
